export const statisticsDataSelector = state => state.statisticsData;

// export const companiesStatisticsSelector = (state) => state.statisticsData?.statistics?.companiesStatistic

// export const usersStatisticSelector = (state) => state.statisticsData?.statistics?.usersStatistic

// export const contactsCountStatisticsSelector = (state) => state.statisticsData?.statistics?.contactsCount